import type { Market } from '@//config/domain-locale-map';
import { getAssignmentOdometerUnit } from '@//utils/odometer';
import type { RangeFacetKeys } from './useEnrichedFacets';

interface GetRangeFacetUnitOptions {
  facetKey: RangeFacetKeys;
  market: Market;
  currencySymbol: string;
  value?: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  t: (key: any) => string;
}

/**
 * Returns the appropriate unit for a range facet, handling market-specific variations
 * and plural forms where applicable.
 */
export const getRangeFacetUnit = ({
  facetKey,
  market,
  currencySymbol,
  value,
  t,
}: GetRangeFacetUnitOptions): string => {
  switch (facetKey) {
    case 'modelYear':
      // No unit needed - year ranges are self-explanatory
      return '';

    case 'price':
      return currencySymbol;

    case 'mileage':
      return getAssignmentOdometerUnit(market);

    case 'odometerValueAsKm':
    case 'enhancedProperties.electricalRangeWLTP.value':
      return t('units.kilometer');

    case 'properties.co2':
      return t('units.gramsPerKilometer');

    case 'properties.seats':
      // Handle plural form for seats
      return value === 1 ? t('units.seat.singular') : t('units.seat.plural');

    case 'enginePower':
      return t('units.horsepower');

    default:
      return '';
  }
};
